export enum PaymentMethod {
  BANK_CARD = 'stripe',
  WALLET = 'wallet',
  PAYPAL = 'paypal',
  WALLET_BANK_CARD = 'wallet_stripe',
  WALLET_PAYPAL = 'wallet_paypal',
  PAYMENT_LINK = 'payment_link',
}
